import { render, staticRenderFns } from "./new-header.vue?vue&type=template&id=5d5e953a&scoped=true&"
import script from "./new-header.vue?vue&type=script&lang=ts&"
export * from "./new-header.vue?vue&type=script&lang=ts&"
import style0 from "./new-header.vue?vue&type=style&index=0&id=5d5e953a&prod&lang=less&scoped=true&"
import style1 from "./new-header.vue?vue&type=style&index=1&id=5d5e953a&prod&lang=less&"
import style2 from "./new-header.vue?vue&type=style&index=2&id=5d5e953a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5e953a",
  null
  
)

export default component.exports